import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

type AgeData = {
  Name: string;
  Value: number;
};

export const DemographicAgeGroup = ({ data }: { data?: AgeData[] }) => {
  const categories = data?.map(item => item.Name) || [];

  const barColors = [
    '#E55050',
    '#008048',
    '#35B1E8',
    '#FFA51F',
    '#FEBEC8',
    '#4C5167',
    '#008044',
    '#35B1E8',
  ];

  // Assign colors to each data point individually
  const chartData = data?.map((item, index) => ({
    y: item.Value,
    color: barColors[index % barColors.length], // cycles through colors
  })) || [];

  const options: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    title: {
      text: 'Demographic Age Group Distribution',
    },
    xAxis: {
      categories,
      labels: {
        style: {
          fontSize: '10px',
          color: 'black',
          textDecoration: 'none',
        },
      },
    },
    yAxis: {
      title: {
        text: 'Number of Participants',
        style: { fontSize: '11px', color: 'black' },
      },
      labels: { style: { fontSize: '11px', color: 'black' } },
    },
    tooltip: {
      pointFormat: 'Participants: <b>{point.y}</b>',
    },
    credits: { enabled: false },
    plotOptions: {
      column: {
        borderRadius: 5,
        dataLabels: { enabled: true },
      },
    },
    series: [
      {
        name: 'Participants',
        type: 'column',
        data: chartData, // ✅ individual colors applied here
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
